import React, {useEffect, useState} from 'react';

import './App.css';
// import * as mobilenet from '@tensorflow-models/mobilenet'
import * as firebase from "firebase/app"
import "firebase/performance"
import "firebase/analytics"
import { CameraView } from './components/CameraView';
import { Predictions } from './components/Predictions';
import { Intro } from './components/Intro'
import * as tf from '@tensorflow/tfjs';
const firebaseConfig = {
  apiKey: "AIzaSyBDfT4gBUwBvFxX7lAr9M6Ad_0UNjn__JA",
  authDomain: "dog-mood.firebaseapp.com",
  databaseURL: "https://dog-mood.firebaseio.com",
  projectId: "dog-mood",
  storageBucket: "dog-mood.appspot.com",
  messagingSenderId: "750444133171",
  appId: "1:750444133171:web:22e46f3d482d46a9655c46",
  measurementId: "G-R2EGF4YF2W"
};


function App() {

    const [imageData, setImageData] = useState(null);
    const [model, setModel] = useState(null);
    const [isModelReady, setIsModelReady] = useState(false);
    const [seenIntro, setSeenIntro] = useState(false);
    const [labels, setLabel] = useState(null);

    useEffect(()=>{
      firebase.initializeApp(firebaseConfig);
      const perf = firebase.performance();
      const analytics = firebase.analytics();

      async function loadModelAndTensorFlow() {
        //Load Model
        await tf.ready();

      }
      loadModelAndTensorFlow();

    },[]);
    const seenIntroCallback = (version) => {

      if(version===1) {
        loadModelBasic().then( ()=>{
          setSeenIntro(true);
        })
      }
      if(version===2) {
        loadModelAdvanced().then( ()=>{
          setSeenIntro(true);
        })
      }
      
    }
    async function loadModelBasic() {
      await setModel(await tf.loadGraphModel(window.location.origin+"/model/model.json"));
      //Load Labels
      let label = await fetch(window.location.origin+"/model/labels.json");
      setLabel(await label.json());
      setIsModelReady(true);
    }
    async function loadModelAdvanced() {
      await setModel(await tf.loadGraphModel(window.location.origin+"/model2/model.json"));
      //Load Labels
      let label = await fetch(window.location.origin+"/model2/labels.json");
      setLabel(await label.json());
      setIsModelReady(true);
    }
    return (
      <div className="App">
        {!seenIntro && <Intro seenIntro={seenIntroCallback}/>}
        {(seenIntro && isModelReady) && <CameraView changeImageData={setImageData}/>}
        {(seenIntro && isModelReady) && <Predictions imageState={imageData} model={model} labels={labels}/>}
      </div>
    );
}

export default App;
 